(() => {
  document.addEventListener('click', event => {
    const play = event.target.closest('[data-artist-review-play]');
    if (!play || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const review = play.closest('[data-artist-review]');
    const template = review.querySelector('[data-artist-review-frame]');
    if (!template) return;
    event.preventDefault();
    const frame = template.content.firstElementChild.cloneNode(true);
    review.replaceChildren(frame);
    frame.focus();
  });
  const initializeVideos = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.sb-artist-story__video').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      video.autoplay = true;
      video.play().catch(() => {});
    });
  };
  const initializeSticky = () => {
    document.querySelectorAll('[data-editorial-sticky]').forEach(bar => {
      if (bar.dataset.initialized) return;
      bar.dataset.initialized = 'true';
      const hero = bar.closest('.sb-artist-story').querySelector('.sb-artist-story__hero');
      if (!hero || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
      const update = entry => { bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; };
      update({isIntersecting: hero.getBoundingClientRect().bottom > 0, boundingClientRect: hero.getBoundingClientRect()});
      new IntersectionObserver(entries => entries.forEach(update)).observe(hero);
    });
  };
  const refresh = () => {
    const engine = window.SBStorefrontPricing;
    if (!engine) return;
    document.querySelectorAll('[data-editorial-sticky]').forEach(bar => {
      const price = engine.resolvePrice({productId: bar.dataset.productId, priceCents: bar.dataset.price, comparePriceCents: bar.dataset.compare});
      if (!Number.isFinite(price.currentPriceCents)) return;
      bar.querySelector('[data-sticky-bottom-current-price] [data-product-price-value]').textContent = engine.formatMoney(price.currentPriceCents, bar.dataset.currency);
      const compare = bar.querySelector('[data-sticky-bottom-compare-price]');
      compare.hidden = !price.hasComparePrice;
      if (price.hasComparePrice) compare.querySelector('[data-product-price-value]').textContent = engine.formatMoney(price.comparePriceCents, bar.dataset.currency);
    });
    document.querySelectorAll('[data-editorial-price]').forEach(row => {
      const price = engine.resolvePrice({productId: row.dataset.productId, priceCents: row.dataset.price, comparePriceCents: row.dataset.compare});
      if (!Number.isFinite(price.currentPriceCents)) return;
      const money = cents => engine.formatMoney(cents, row.dataset.currency);
      row.querySelector('[data-editorial-current]').textContent = money(price.currentPriceCents);
      row.querySelector('[data-editorial-compare]').hidden = !price.hasComparePrice;
      row.querySelector('[data-editorial-saving]').hidden = !price.hasComparePrice;
      if (price.hasComparePrice) {
        row.querySelector('[data-editorial-compare-value]').textContent = money(price.comparePriceCents);
        const difference = price.comparePriceCents - price.currentPriceCents;
        row.querySelector('[data-editorial-saving]').textContent = row.dataset.savingTemplate
          .replace('__AMOUNT__', money(difference))
          .replace('__PERCENT__', String(Math.round(difference / price.comparePriceCents * 100)));
      }
    });
  };
  document.addEventListener('sb:storefront-pricing:changed', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:load', initializeVideos);
  document.addEventListener('shopify:section:load', initializeSticky);
  refresh();
  initializeVideos();
  initializeSticky();
})();
